import React from 'react';
import { Link } from 'react-router-dom';

const InfoPage = ({ title, subtitle, children, lastUpdated }) => {
  return (
    <main style={{ backgroundColor: '#FAFAF7' }}>
      <div className="max-w-[820px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <Link to="/" className="text-[12px] uppercase tracking-[0.18em] underline-offset-4 hover:underline" style={{ color: '#2D5A3D' }}>
          ← Back to home
        </Link>
        <h1 className="font-serif text-[40px] md:text-[56px] mt-4 leading-[1.05]" style={{ color: '#2C2418' }}>
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 text-[15px] opacity-80" style={{ color: '#2C2418' }}>
            {subtitle}
          </p>
        )}
        {lastUpdated && (
          <p className="mt-1 text-[12px] opacity-60" style={{ color: '#2C2418' }}>
            Last updated: {lastUpdated}
          </p>
        )}
        <div className="mt-10 space-y-7 text-[15px] leading-[1.7]" style={{ color: '#2C2418' }}>
          {children}
        </div>
      </div>
    </main>
  );
};

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-serif text-[24px] md:text-[28px] mb-3" style={{ color: '#2D5A3D' }}>
      {heading}
    </h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export default InfoPage;
